import DocMenuConfig from "@/core/config/MainMenuConfig";
import router from "@/router/index";
import utils from "@/utils/index";
import config from "@/configApp";

export const menu = {
  namespaced: true,
  state: { menu: [] },
  actions: {
    montarMenu({ commit }, user) {
      try {
        var permissoes = user.User.TipoUsuario.Restricao;
        var permissoesEmitente =
          user.User.EmitenteTipoUsuario.EmitenteRestricao;

        var rotas = [];

        //#region Variáveis

        //#region Variáveis - Navegação principal
        var navegacao = {
          heading: "Gestão",
          route: `/${utils.getWL()}/principal`,
          pages: [],
        };

        var emitentesModulo = null;
        var emitentesRota = null;
        var softwareHouseModulo = null;
        var softwareHouseRota = null;
        var configuracaoWhiteLabelModulo = null;
        var configuracaoWhiteLabelRota = null;
        var restricoesModulo = null;
        var restricoesRota = null;
        var gerenciadorPainelGestorModulo = null;
        var gerenciadorPainelGestorRota = null;
        var ajudasModulo = null;
        var ajudasRota = null;
        var revendaModulo = null;
        var licencaRecebivelModulo = null;
        //#endregion

        //#region Variáveis - Cadastros
        var cadastros = {
          heading: "Cadastros",
          route: `/${utils.getWL()}/cadastros`,
          pages: [],
        };

        var clientesModulo = null;
        var clientesRota = null;
        var produtosModulo = null;
        var produtosRota = null;
        var transportadorasModulo = null;
        var transportadorasRota = null;
        var fornecedoresModulo = null;
        var fornecedoresRota = null;
        var vendedoresModulo = null;
        var vendedoresRota = null;
        var motoristasModulo = null;
        var motoristasRota = null;
        //#endregion

        //#region Variáveis - Movimentação
        var movimentacao = {
          heading: "Movimentação",
          route: `/${utils.getWL()}/movimentacao`,
          pages: [],
        };

        var faturamentoModulo = null;
        var faturamentoRota = null;
        var gerenciadorNFeModulo = null;
        var gerenciadorNFeRota = null;
        var pedidosModulo = null;
        var pedidosRota = null;
        var pdvModulo = null;
        var pdvRota = null;
        var compraModulo = null;
        var compraRota = null;
        //#endregion

        //#region Variáveis - Financeiro
        var financeiro = {
          heading: "Financeiro",
          route: `/${utils.getWL()}/financeiro`,
          pages: [],
        };

        var condicoesModulo = null;
        var condicoesRota = null;
        var especiesModulo = null;
        var especiesRota = null;
        var custosModulo = null;
        var custosRota = null;
        var contasModulo = null;
        var contasRota = null;
        var receberModulo = null;
        var receberRota = null;
        var pagarModulo = null;
        var pagarRota = null;
        //#endregion

        //#region Variáveis - Relatórios
        var relatorios = {
          heading: "Relatórios",
          route: `/${utils.getWL()}/relatorios`,
          pages: [],
        };

        var relatoriosModulo = null;
        var relatoriosRota = null;
        //#endregion

        //#region Variáveis - Configurações
        var configuracoes = {
          heading: "Configurações",
          route: `/${utils.getWL()}/configuracoes`,
          pages: [],
        };

        var usuariosModulo = null;
        var usuariosRota = null;
        var emitenteRestricoesModulo = null;
        var emitenteRestricoesRota = null;
        var configuracoesModulo = null;
        var configuracoesRota = null;
        var auditoriaModulo = null;
        var auditoriaRota = null;
        //#endregion

        //#region Variáveis - Suporte
        var suporte = {
          heading: "Suporte",
          route: `/${utils.getWL()}/suporte`,
          pages: [],
        };

        var suporteAjudaModulo = null;
        var suporteAjudaRota = null;
        var ticketModulo = null;
        var ticketRota = null;

        var licenca = {
          heading: "Licença",
          route: `/${utils.getWL()}/licenca`,
          pages: [],
        };

        var licencaFaturaEmitenteModulo = null;
        var licencaFaturaEmitenteRota = null;

        //#endregion

        //#endregion

        //#region Menus

        //#region Menu - Navegação principal

        //#region Menu - Navegação principal - Empresas
        if (
          user.User.TipoUsuario.tipo === "Administrador" ||
          user.User.TipoUsuario.tipo === "Distribuidor Master" ||
          user.User.TipoUsuario.tipo === "Distribuidor" ||
          user.User.TipoUsuario.tipo === "Revenda"
        ) {
          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.Emitente.Consultar"
            )
          ) {
            emitentesModulo = {
              ordem: 1,
              sectionTitle: "Empresas",
              route: `/${utils.getWL()}/principal/empresas`,
              svgIcon: "media/icons/duotune/ecommerce/ecm004.svg",
              fontIcon: "bi-shop",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/principal/empresas/consultar`,
                },
              ],
            };

            emitentesRota = {
              path: "/:url/principal/empresas/consultar",
              name: "principal/empresas/consultar",
              component: () => import("@/views/empresas/Consultar.vue"),
              meta: {
                pageTitle: "Empresas",
                breadcrumbs: ["Consultar"],
              },
            };

            navegacao.pages.push(emitentesModulo);
            rotas.push(emitentesRota);
          }

          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.Emitente.Incluir"
            )
          ) {
            var emitenteAdicionarModulo = {
              heading: "Adicionar",
              route: `/${utils.getWL()}/principal/empresas/editar`,
            };

            var emitenteAdicionarRotas = {
              path: "/:url/principal/empresas/editar",
              name: "principal/empresas/editar",
              component: () => import("@/views/empresas/Editar.vue"),
              meta: {
                pageTitle: "Empresas",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            if (emitentesModulo !== null) {
              emitentesModulo.sub.push(emitenteAdicionarModulo);
            }

            rotas.push(emitenteAdicionarRotas);
          }

          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.Emitente.Alterar"
            )
          ) {
            var emitenteEditarRotas = {
              path: "/:url/principal/empresas/editar/:id",
              name: "principal/empresas/editar/:id",
              component: () => import("@/views/empresas/Editar.vue"),
              meta: {
                pageTitle: "Empresas",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            rotas.push(emitenteEditarRotas);
          }
        }

        if (user.User.TipoUsuario.tipo === "Administrador") {
          if (
            permissoes.find(
              (modulo) =>
                modulo.regra == "Permitir.EmitenteSoftwareHouse.Consultar"
            )
          ) {
            var emitenteSoftwareHouseConsultarModulo = {
              heading: "Gerenciar",
              route: `/${utils.getWL()}/principal/empresas/gerenciar`,
            };

            var emitenteSoftwareHouseConsultarRotas = {
              path: "/:url/principal/empresas/gerenciar",
              name: "principal/empresas/gerenciar",
              component: () => import("@/views/empresas/Gerenciar.vue"),
              meta: {
                pageTitle: "Empresas",
                breadcrumbs: ["Consultar", "Gerenciar"],
              },
            };

            if (emitentesModulo !== null) {
              emitentesModulo.sub.push(emitenteSoftwareHouseConsultarModulo);
            }

            rotas.push(emitenteSoftwareHouseConsultarRotas);
          }
        }
        //#endregion

        //#region Menu - Navegação principal - SoftwareHouse
        if (user.User.TipoUsuario.tipo === "Administrador") {
          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.SoftwareHouse.Consultar"
            )
          ) {
            softwareHouseModulo = {
              ordem: 2,
              sectionTitle: "SoftwareHouse",
              route: `/${utils.getWL()}/principal/softwarehouse`,
              svgIcon: "media/icons/duotune/finance/fin001.svg",
              fontIcon: "bi-house-door",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/principal/softwarehouse/consultar`,
                },
              ],
            };

            softwareHouseRota = {
              path: "/:url/principal/softwarehouse/consultar",
              name: "principal/softwareHouse/consultar",
              component: () => import("@/views/softwarehouse/Consultar.vue"),
              meta: {
                pageTitle: "SoftwareHouse",
                breadcrumbs: ["Consultar"],
              },
            };

            navegacao.pages.push(softwareHouseModulo);
            rotas.push(softwareHouseRota);
          }

          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.SoftwareHouse.Incluir"
            )
          ) {
            var softwarehouseAdicionarModulo = {
              heading: "Adicionar",
              route: `/${utils.getWL()}/principal/softwarehouse/editar`,
            };

            var softwarehouseAdicionarRotas = {
              path: "/:url/principal/softwarehouse/editar",
              name: "principal/softwarehouse/editar",
              component: () => import("@/views/softwarehouse/Editar.vue"),
              meta: {
                pageTitle: "SoftwareHouse",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            if (softwareHouseModulo !== null) {
              softwareHouseModulo.sub.push(softwarehouseAdicionarModulo);
            }

            rotas.push(softwarehouseAdicionarRotas);
          }

          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.SoftwareHouse.Alterar"
            )
          ) {
            var softwarehouseEditarRotas = {
              path: "/:url/principal/softwarehouse/editar/:id",
              name: "principal/softwarehouse/editar/:id",
              component: () => import("@/views/softwarehouse/Editar.vue"),
              meta: {
                pageTitle: "SoftwareHouse",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            rotas.push(softwarehouseEditarRotas);
          }
        }
        //#endregion

        //#region Menu - Navegação principal - ConfiguracaoWhiteLabel
        if (
          user.User.TipoUsuario.tipo === "Administrador" ||
          user.User.TipoUsuario.tipo === "Distribuidor Master" ||
          user.User.TipoUsuario.tipo === "Distribuidor" ||
          user.User.TipoUsuario.tipo === "Revenda"
        ) {
          if (
            permissoes.find(
              (modulo) =>
                modulo.regra == "Permitir.ConfiguracaoWhiteLabel.Consultar"
            )
          ) {
            configuracaoWhiteLabelModulo = {
              ordem: 3,
              sectionTitle: "White Label",
              route: `/${utils.getWL()}/principal/configuracaowhitelabel`,
              svgIcon: "media/icons/duotune/general/gen062.svg",
              fontIcon: "bi bi-display",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/principal/configuracaowhitelabel/consultar`,
                },
              ],
            };

            configuracaoWhiteLabelRota = {
              path: "/:url/principal/configuracaowhitelabel/consultar",
              name: "principal/configuracaowhitelabel/consultar",
              component: () => import("@/views/whitelabel/Consultar.vue"),
              meta: {
                pageTitle: "White Label",
                breadcrumbs: ["Consultar"],
              },
            };

            navegacao.pages.push(configuracaoWhiteLabelModulo);
            rotas.push(configuracaoWhiteLabelRota);
          }

          if (
            user.User.TipoUsuario.tipo === "Administrador" &&
            permissoes.find(
              (modulo) =>
                modulo.regra == "Permitir.ConfiguracaoWhiteLabel.Incluir"
            )
          ) {
            var configuracaoWhiteLabelAdicionarModulo = {
              heading: "Adicionar",
              route: `/${utils.getWL()}/principal/configuracaowhitelabel/editar`,
            };

            var configuracaoWhiteLabelAdicionarRotas = {
              path: "/:url/principal/configuracaowhitelabel/editar",
              name: "principal/configuracaowhitelabel/editar",
              component: () => import("@/views/whitelabel/Editar.vue"),
              meta: {
                pageTitle: "White Label",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            if (configuracaoWhiteLabelModulo !== null) {
              configuracaoWhiteLabelModulo.sub.push(
                configuracaoWhiteLabelAdicionarModulo
              );
            }

            rotas.push(configuracaoWhiteLabelAdicionarRotas);
          }

          if (
            permissoes.find(
              (modulo) =>
                modulo.regra == "Permitir.ConfiguracaoWhiteLabel.Alterar"
            )
          ) {
            var configuracaoWhiteLabelEditarRotas = {
              path: "/:url/principal/configuracaowhitelabel/editar/:id",
              name: "principal/configuracaowhitelabel/editar/:id",
              component: () => import("@/views/whitelabel/Editar.vue"),
              meta: {
                pageTitle: "White Label",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            rotas.push(configuracaoWhiteLabelEditarRotas);
          }
        }
        //#endregion

        //#region Menu - Navegação principal - Restrições Administrativas
        if (user.User.TipoUsuario.tipo === "Administrador") {
          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.Restricao.Consultar"
            )
          ) {
            restricoesModulo = {
              ordem: 4,
              sectionTitle: "Restrições Administrativas",
              route: `/${utils.getWL()}/principal/restricoes`,
              svgIcon: "media/icons/duotune/general/gen051.svg",
              fontIcon: "bi-shield-lock",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/principal/restricoes/consultar`,
                },
              ],
            };

            restricoesRota = {
              path: "/:url/principal/restricoes/consultar",
              name: "principal/restricoes/consultar",
              component: () => import("@/views/restricoes/Consultar.vue"),
              meta: {
                pageTitle: "Restrições",
                breadcrumbs: ["Consultar"],
              },
            };

            navegacao.pages.push(restricoesModulo);
            rotas.push(restricoesRota);
          }

          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.RestricaoPadrao.Consultar"
            )
          ) {
            var restricoesPadraoConsultarModulo = {
              heading: "Gerenciar",
              route: `/${utils.getWL()}/principal/restricoes/gerenciar`,
            };

            var restricoesPadraoConsultarRotas = {
              path: "/:url/principal/restricoes/gerenciar",
              name: "principal/restricoes/gerenciar",
              component: () => import("@/views/restricoes/Gerenciar.vue"),
              meta: {
                pageTitle: "Restrições",
                breadcrumbs: ["Consultar", "Gerenciar"],
              },
            };

            if (restricoesModulo !== null) {
              restricoesModulo.sub.push(restricoesPadraoConsultarModulo);
            }

            rotas.push(restricoesPadraoConsultarRotas);
          }
        }
        //#endregion

        //#region Menu - Navegação principal - Painel do Gestor
        if (user.User.TipoUsuario.tipo === "Administrador") {
          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.Gestor.Gerenciar"
            )
          ) {
            gerenciadorPainelGestorModulo = {
              ordem: 5,
              sectionTitle: "Painel do Gestor",
              route: `/${utils.getWL()}/principal/gestor`,
              svgIcon: "media/icons/duotune/general/gen019.svg",
              fontIcon: "bi bi-toggles",
              sub: [
                {
                  heading: "Gerenciar",
                  route: `/${utils.getWL()}/principal/gestor/gerenciar`,
                },
              ],
            };

            gerenciadorPainelGestorRota = {
              path: "/:url/principal/gestor/gerenciar",
              name: "principal/gestor/gerenciar",
              component: () => import("@/views/gestor/Gerenciar.vue"),
              meta: {
                pageTitle: "Painel do Gestor",
                breadcrumbs: ["Gerenciar"],
              },
            };

            navegacao.pages.push(gerenciadorPainelGestorModulo);
            rotas.push(gerenciadorPainelGestorRota);
          }
        }
        //#endregion

        //#region Menu - Navegação principal - Gestão Revenda
        if (
          permissoes.find(
            (modulo) => modulo.regra == "Permitir.GestaoRevendas.Gerenciar"
          )
        ) {
          revendaModulo = {
            ordem: 6,
            sectionTitle: "Gerenciar Revenda",
            route: `/${utils.getWL()}/principal/revenda`,
            svgIcon: "media/icons/duotune/communication/com005.svg",
            fontIcon: "bi bi-toggles",
            sub: [],
          };

          if (user.User.TipoUsuario.tipo === "Administrador") {
            if (
              permissoes.find(
                (modulo) =>
                  modulo.regra == "Permitir.DistribuidorMaster.Consultar"
              )
            ) {
              revendaModulo.sub.push({
                heading: "Distribuidor Master",
                route: `/${utils.getWL()}/principal/revenda/distribuidormaster`,
              });

              let distribuidorMasterRotas = {
                path: "/:url/principal/revenda/distribuidormaster",
                name: "principal/revenda/distribuidormaster",
                component: () =>
                  import("@/views/revenda/distribuidormaster/Consultar.vue"),
                meta: {
                  pageTitle: "Distribuidor Master",
                  breadcrumbs: ["Revenda", "Distribuidor Master", "Consultar"],
                },
              };

              rotas.push(distribuidorMasterRotas);
            }

            if (
              permissoes.find(
                (modulo) =>
                  modulo.regra == "Permitir.DistribuidorMaster.Incluir"
              )
            ) {
              let incluir = {
                path: "/:url/principal/revenda/distribuidormaster/editar",
                name: "principal/revenda/distribuidormaster/editar",
                component: () =>
                  import("@/views/revenda/distribuidormaster/Editar.vue"),
                meta: {
                  pageTitle: "Distribuidor Master",
                  breadcrumbs: ["Revenda", "Distribuidor Master", "Editar"],
                },
              };

              rotas.push(incluir);
            }

            if (
              permissoes.find(
                (modulo) =>
                  modulo.regra == "Permitir.DistribuidorMaster.Alterar"
              )
            ) {
              let incluir = {
                path: "/:url/principal/revenda/distribuidormaster/editar/:id",
                name: "principal/revenda/distribuidormaster/editar/:id",
                component: () =>
                  import("@/views/revenda/distribuidormaster/Editar.vue"),
                meta: {
                  pageTitle: "Distribuidor Master",
                  breadcrumbs: ["Revenda", "Distribuidor Master", "Editar"],
                },
              };

              rotas.push(incluir);
            }
          }

          if (
            user.User.TipoUsuario.tipo === "Administrador" ||
            user.User.TipoUsuario.tipo === "Distribuidor Master"
          ) {
            if (
              permissoes.find(
                (modulo) => modulo.regra == "Permitir.Distribuidor.Consultar"
              )
            ) {
              revendaModulo.sub.push({
                heading: "Distribuidor",
                route: `/${utils.getWL()}/principal/revenda/distribuidor`,
              });

              let distribuidorRotas = {
                path: "/:url/principal/revenda/distribuidor",
                name: "principal/revenda/distribuidor",
                component: () =>
                  import("@/views/revenda/distribuidor/Consultar.vue"),
                meta: {
                  pageTitle: "Distribuidor",
                  breadcrumbs: ["Revenda", "Distribuidor", "Consultar"],
                },
              };

              rotas.push(distribuidorRotas);
            }

            if (
              permissoes.find(
                (modulo) => modulo.regra == "Permitir.Distribuidor.Incluir"
              )
            ) {
              let incluir = {
                path: "/:url/principal/revenda/distribuidor/editar",
                name: "principal/revenda/distribuidor/editar",
                component: () =>
                  import("@/views/revenda/distribuidor/Editar.vue"),
                meta: {
                  pageTitle: "Distribuidor",
                  breadcrumbs: ["Revenda", "Distribuidor", "Editar"],
                },
              };

              rotas.push(incluir);
            }

            if (
              permissoes.find(
                (modulo) => modulo.regra == "Permitir.Distribuidor.Alterar"
              )
            ) {
              let incluir = {
                path: "/:url/principal/revenda/distribuidor/editar/:id",
                name: "principal/revenda/distribuidor/editar/:id",
                component: () =>
                  import("@/views/revenda/distribuidor/Editar.vue"),
                meta: {
                  pageTitle: "Distribuidor",
                  breadcrumbs: ["Revenda", "Distribuidor", "Editar"],
                },
              };

              rotas.push(incluir);
            }
          }

          if (
            user.User.TipoUsuario.tipo === "Administrador" ||
            user.User.TipoUsuario.tipo === "Distribuidor Master" ||
            user.User.TipoUsuario.tipo === "Distribuidor"
          ) {
            if (
              permissoes.find(
                (modulo) => modulo.regra == "Permitir.Revenda.Consultar"
              )
            ) {
              revendaModulo.sub.push({
                heading: "Revenda",
                route: `/${utils.getWL()}/principal/revenda/revenda`,
              });

              let revendaRotas = {
                path: "/:url/principal/revenda/revenda",
                name: "principal/revenda/revenda",
                component: () =>
                  import("@/views/revenda/revenda/Consultar.vue"),
                meta: {
                  pageTitle: "Revenda",
                  breadcrumbs: ["Revenda", "Revenda", "Consultar"],
                },
              };

              rotas.push(revendaRotas);
            }

            if (
              permissoes.find(
                (modulo) => modulo.regra == "Permitir.Revenda.Incluir"
              )
            ) {
              let incluir = {
                path: "/:url/principal/revenda/revenda/editar",
                name: "principal/revenda/revenda/editar",
                component: () => import("@/views/revenda/revenda/Editar.vue"),
                meta: {
                  pageTitle: "Revenda",
                  breadcrumbs: ["Revenda", "Revenda", "Editar"],
                },
              };

              rotas.push(incluir);
            }

            if (
              permissoes.find(
                (modulo) => modulo.regra == "Permitir.Revenda.Alterar"
              )
            ) {
              let incluir = {
                path: "/:url/principal/revenda/revenda/editar/:id",
                name: "principal/revenda/revenda/editar/:id",
                component: () => import("@/views/revenda/revenda/Editar.vue"),
                meta: {
                  pageTitle: "Revenda",
                  breadcrumbs: ["Revenda", "Revenda", "Editar"],
                },
              };

              rotas.push(incluir);
            }
          }

          //Vendedor Revenda
          // if (
          //   user.User.TipoUsuario.tipo === "Administrador" ||
          //   user.User.TipoUsuario.tipo === "Distribuidor Master" ||
          //   user.User.TipoUsuario.tipo === "Distribuidor" ||
          //   user.User.TipoUsuario.tipo === "Revenda"
          // ) {
          //   if (
          //     permissoes.find(
          //       (modulo) => modulo.regra == "Permitir.VendedorRevenda.Consultar"
          //     )
          //   ) {
          //     revendaModulo.sub.push({
          //       heading: "Vendedores Revenda",
          //       route: `/${utils.getWL()}/principal/revenda/vendedorrevenda`,
          //     });

          //     let vendedorRevendaRotas = {
          //       path: "/:url/principal/revenda/vendedorrevenda",
          //       name: "principal/revenda/vendedorrevenda",
          //       component: () =>
          //         import("@/views/revenda/vendedorrevenda/Consultar.vue"),
          //       meta: {
          //         pageTitle: "Vendedores Revenda",
          //         breadcrumbs: ["Revenda", "Vendedores Revenda", "Consultar"],
          //       },
          //     };

          //     rotas.push(vendedorRevendaRotas);
          //   }
          // }

          if (revendaModulo.sub && revendaModulo.sub.length > 0) {
            navegacao.pages.push(revendaModulo);
          }
        }
        //#endregion

        //#region Menu - Navegação principal - Licença Recebiveis

        if (
          user.User.TipoUsuario.tipo === "Administrador" ||
          user.User.TipoUsuario.tipo === "Distribuidor Master" ||
          user.User.TipoUsuario.tipo === "Distribuidor" ||
          user.User.TipoUsuario.tipo === "Revenda"
        ) {
          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.LicencaRecebivel.Consultar"
            )
          ) {
            licencaRecebivelModulo = {
              ordem: 7,
              sectionTitle: "Financeiro - Licenças",
              route: `/${utils.getWL()}/principal/licencarecebivel`,
              svgIcon: "media/icons/duotune/finance/fin005.svg",
              fontIcon: "bi bi-toggles",
              sub: [],
            };

            licencaRecebivelModulo.sub.push({
              heading:
                user.User.TipoUsuario.tipo === "Administrador" ||
                user.User.TipoUsuario.tipo === "Distribuidor Master"
                  ? "Faturas a Receber"
                  : "Faturas a Pagar",
              route: `/${utils.getWL()}/principal/licencarecebivel/consultar`,
            });

            let licencaRecebivelRotas = {
              path: "/:url/principal/licencarecebivel/consultar",
              name: "principal/licencarecebivel/consultar",
              component: () => import("@/views/licencarecebivel/Consultar.vue"),
              meta: {
                pageTitle: "Financeiro - Faturas",
                breadcrumbs: ["Financeiro - Faturas", "Consultar"],
              },
            };

            /*if (user.User.TipoUsuario.tipo === "Revenda") {
              if (
                permissoes.find(
                  (modulo) =>
                    modulo.regra == "Permitir.LicencaRecebivel.Consultar"
                )
              ) {
                let consultarReceberModulo = {
                  heading: "Faturas a Receber",
                  route: `/${utils.getWL()}/principal/licencarecebivel/consultarreceber`,
                };

                let consultarReceberRotas = {
                  path: "/:url/principal/licencarecebivel/consultarreceber",
                  name: "principal/licencarecebivel/consultarreceber",
                  component: () =>
                    import("@/views/licencarecebivel/ConsultarReceber.vue"),
                  meta: {
                    pageTitle: "Consultar Receber",
                    breadcrumbs: ["Consultar Receber", "Gerenciar"],
                  },
                };

                if (licencaRecebivelModulo !== null) {
                  licencaRecebivelModulo.sub.push(consultarReceberModulo);
                }

                rotas.push(consultarReceberRotas);
              }
            }*/

            licencaRecebivelModulo.sub.push({
              heading: "Licenças",
              route: `/${utils.getWL()}/principal/licencarecebivel/consultarlicencas`,
            });

            let licencasRotas = {
              path: "/:url/principal/licencarecebivel/consultarlicencas",
              name: "principal/licencarecebivel/consultarlicencas",
              component: () =>
                import("@/views/licencarecebivel/ConsultarLicencas.vue"),
              meta: {
                pageTitle: "Financeiro - Licenças",
                breadcrumbs: ["Financeiro - Licenças", "Consultar"],
              },
            };

            rotas.push(licencaRecebivelRotas);
            rotas.push(licencasRotas);

            if (
              licencaRecebivelModulo.sub &&
              licencaRecebivelModulo.sub.length > 0
            ) {
              navegacao.pages.push(licencaRecebivelModulo);
            }
          }

          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.AtualizacaoPlano.Gerenciar"
            )
          ) {
            let gerenciarAtualizacaoPlanoModulo = {
              heading: "Atualizações de Plano",
              route: `/${utils.getWL()}/principal/licencarecebivel/atualizacoesplano`,
            };

            let gerenciarAtualizacaoPlanoRotas = {
              path: "/:url/principal/licencarecebivel/atualizacoesplano",
              name: "principal/licencarecebivel/atualizacoesplano",
              component: () =>
                import("@/views/licencarecebivel/AtualizacoesPlano.vue"),
              meta: {
                pageTitle: "Atualizações de Plano",
                breadcrumbs: ["Atualizações de Plano", "Gerenciar"],
              },
            };

            if (licencaRecebivelModulo !== null) {
              licencaRecebivelModulo.sub.push(gerenciarAtualizacaoPlanoModulo);
            }

            rotas.push(gerenciarAtualizacaoPlanoRotas);
          }

          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.BloqueioLicenca.Consultar"
            )
          ) {
            let consultarBloqueioLicenca = {
              heading: "Bloqueio",
              route: `/${utils.getWL()}/principal/licencarecebivel/consultarbloqueio`,
            };

            let consultarBloqueioLicencaRotas = {
              path: "/:url/principal/licencarecebivel/consultarbloqueio",
              name: "principal/licencarecebivel/consultarbloqueio",
              component: () =>
                import("@/views/licencarecebivel/ConsultarBloqueio.vue"),
              meta: {
                pageTitle: "Bloqueio",
                breadcrumbs: ["Bloqueio", "Consultar"],
              },
            };

            if (licencaRecebivelModulo !== null) {
              licencaRecebivelModulo.sub.push(consultarBloqueioLicenca);
            }

            rotas.push(consultarBloqueioLicencaRotas);
          }
        }

        //#endregion

        //#region Menu - Navegação principal - Ajuda
        if (user.User.TipoUsuario.tipo === "Administrador") {
          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.Ajuda.Consultar"
            )
          ) {
            ajudasModulo = {
              ordem: 8,
              sectionTitle: "Ajuda",
              route: `/${utils.getWL()}/principal/ajuda`,
              svgIcon: "media/icons/duotune/general/gen046.svg",
              fontIcon: "bi-question-circle-fill",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/principal/ajuda/consultar`,
                },
              ],
            };

            ajudasRota = {
              path: "/:url/principal/ajuda/consultar",
              name: "principal/ajuda/consultar",
              component: () => import("@/views/ajuda/Consultar.vue"),
              meta: {
                pageTitle: "Ajuda",
                breadcrumbs: ["Consultar"],
              },
            };

            navegacao.pages.push(ajudasModulo);
            rotas.push(ajudasRota);
          }

          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.Ajuda.Incluir"
            )
          ) {
            var ajudaAdicionarModulo = {
              heading: "Adicionar",
              route: `/${utils.getWL()}/principal/ajuda/editar`,
            };

            var ajudaAdicionarRotas = {
              path: "/:url/principal/ajuda/editar",
              name: "principal/ajuda/editar",
              component: () => import("@/views/ajuda/Editar.vue"),
              meta: {
                pageTitle: "Ajuda",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            if (ajudasModulo !== null) {
              ajudasModulo.sub.push(ajudaAdicionarModulo);
            }

            rotas.push(ajudaAdicionarRotas);
          }

          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.Ajuda.Alterar"
            )
          ) {
            var ajudaEditarRotas = {
              path: "/:url/principal/ajuda/editar/:id",
              name: "principal/ajuda/editar/:id",
              component: () => import("@/views/ajuda/Editar.vue"),
              meta: {
                pageTitle: "Ajuda",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            rotas.push(ajudaEditarRotas);
          }
        }
        //#endregion

        //#endregion

        //#region Menu - Cadastros

        //#region Menu - Cadastros - Clientes
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Cliente.Consultar"
          )
        ) {
          clientesModulo = {
            ordem: 1,
            sectionTitle: "Clientes",
            route: `/${utils.getWL()}/cadastros/clientes`,
            svgIcon: "media/icons/duotune/communication/com005.svg",
            fontIcon: "bi-file-person-fill",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/cadastros/clientes/consultar`,
              },
            ],
          };

          clientesRota = {
            path: "/:url/cadastros/clientes/consultar",
            name: "cadastros/clientes/consultar",
            component: () => import("@/views/clientes/Consultar.vue"),
            meta: {
              pageTitle: "Clientes",
              breadcrumbs: ["Consultar"],
            },
          };

          cadastros.pages.push(clientesModulo);
          rotas.push(clientesRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Cliente.Incluir"
          )
        ) {
          var clientesAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/cadastros/clientes/editar`,
          };

          var clientesAdicionarRotas = {
            path: "/:url/cadastros/clientes/editar",
            name: "cadastros/clientes/editar",
            component: () => import("@/views/clientes/Editar.vue"),
            meta: {
              pageTitle: "Clientes",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (clientesModulo !== null) {
            clientesModulo.sub.push(clientesAdicionarModulo);
          }

          rotas.push(clientesAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Cliente.Alterar"
          )
        ) {
          var clientesEditarRotas = {
            path: "/:url/cadastros/clientes/editar/:id",
            name: "cadastros/clientes/editar/:id",
            component: () => import("@/views/clientes/Editar.vue"),
            meta: {
              pageTitle: "Clientes",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(clientesEditarRotas);
        }
        //#endregion

        //#region Menu - Cadastros - Produtos
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Produto.Consultar"
          )
        ) {
          produtosModulo = {
            ordem: 2,
            sectionTitle: "Produtos",
            route: `/${utils.getWL()}/cadastros/produtos`,
            svgIcon: "media/icons/duotune/ecommerce/ecm009.svg",
            fontIcon: "bi-boxes",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/cadastros/produtos/consultar`,
              },
            ],
          };

          produtosRota = {
            path: "/:url/cadastros/produtos/consultar",
            name: "cadastros/produtos/consultar",
            component: () => import("@/views/produtos/Consultar.vue"),
            meta: {
              pageTitle: "Produtos",
              breadcrumbs: ["Consultar"],
            },
          };

          cadastros.pages.push(produtosModulo);
          rotas.push(produtosRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Produto.Incluir"
          )
        ) {
          var produtosAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/cadastros/produtos/editar`,
          };

          var produtosAdicionarRotas = {
            path: "/:url/cadastros/produtos/editar",
            name: "cadastros/produtos/editar",
            component: () => import("@/views/produtos/Editar.vue"),
            meta: {
              pageTitle: "Produtos",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (produtosModulo !== null) {
            produtosModulo.sub.push(produtosAdicionarModulo);
          }

          rotas.push(produtosAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Produto.Alterar"
          )
        ) {
          var produtosEditarRotas = {
            path: "/:url/cadastros/produtos/editar/:id",
            name: "cadastros/produtos/editar/:id",
            component: () => import("@/views/produtos/Editar.vue"),
            meta: {
              pageTitle: "Produtos",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(produtosEditarRotas);
        }
        //#endregion

        //#region Menu - Cadastros - Transportadoras
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Transportadora.Consultar"
          )
        ) {
          transportadorasModulo = {
            ordem: 3,
            sectionTitle: "Transportadoras",
            route: `/${utils.getWL()}/cadastros/transportadoras`,
            svgIcon: "media/icons/duotune/ecommerce/ecm006.svg",
            fontIcon: "bi-truck",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/cadastros/transportadoras/consultar`,
              },
            ],
          };

          transportadorasRota = {
            path: "/:url/cadastros/transportadoras/consultar",
            name: "cadastros/transportadoras/consultar",
            component: () => import("@/views/transportadoras/Consultar.vue"),
            meta: {
              pageTitle: "Transportadoras",
              breadcrumbs: ["Consultar"],
            },
          };

          cadastros.pages.push(transportadorasModulo);
          rotas.push(transportadorasRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Transportadora.Incluir"
          )
        ) {
          var transportadorasAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/cadastros/transportadoras/editar`,
          };

          var transportadorasAdicionarRotas = {
            path: "/:url/cadastros/transportadoras/editar",
            name: "cadastros/transportadoras/editar",
            component: () => import("@/views/transportadoras/Editar.vue"),
            meta: {
              pageTitle: "Transportadoras",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (transportadorasModulo !== null) {
            transportadorasModulo.sub.push(transportadorasAdicionarModulo);
          }

          rotas.push(transportadorasAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Transportadora.Alterar"
          )
        ) {
          var transportadorasEditarRotas = {
            path: "/:url/cadastros/transportadoras/editar/:id",
            name: "cadastros/transportadoras/editar/:id",
            component: () => import("@/views/transportadoras/Editar.vue"),
            meta: {
              pageTitle: "Transportadoras",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(transportadorasEditarRotas);
        }
        //#endregion

        //#region Menu - Cadastros - Fornecedores
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Fornecedor.Consultar"
          )
        ) {
          fornecedoresModulo = {
            ordem: 4,
            sectionTitle: "Fornecedores",
            route: `/${utils.getWL()}/cadastros/fornecedores`,
            svgIcon: "media/icons/duotune/communication/com014.svg",
            fontIcon: "bi-people-fill",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/cadastros/fornecedores/consultar`,
              },
            ],
          };

          fornecedoresRota = {
            path: "/:url/cadastros/fornecedores/consultar",
            name: "cadastros/fornecedores/consultar",
            component: () => import("@/views/fornecedores/Consultar.vue"),
            meta: {
              pageTitle: "Fornecedores",
              breadcrumbs: ["Consultar"],
            },
          };

          cadastros.pages.push(fornecedoresModulo);
          rotas.push(fornecedoresRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Fornecedor.Incluir"
          )
        ) {
          var fornecedoresAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/cadastros/fornecedores/editar`,
          };

          var fornecedoresAdicionarRotas = {
            path: "/:url/cadastros/fornecedores/editar",
            name: "cadastros/fornecedores/editar",
            component: () => import("@/views/fornecedores/Editar.vue"),
            meta: {
              pageTitle: "Fornecedores",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (fornecedoresModulo !== null) {
            fornecedoresModulo.sub.push(fornecedoresAdicionarModulo);
          }

          rotas.push(fornecedoresAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Fornecedor.Alterar"
          )
        ) {
          var fornecedoresEditarRotas = {
            path: "/:url/cadastros/fornecedores/editar/:id",
            name: "cadastros/fornecedores/editar/:id",
            component: () => import("@/views/fornecedores/Editar.vue"),
            meta: {
              pageTitle: "Fornecedores",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(fornecedoresEditarRotas);
        }
        //#endregion

        //#region Menu - Cadastros - Vendedores
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Vendedor.Consultar"
          )
        ) {
          vendedoresModulo = {
            ordem: 5,
            sectionTitle: "Vendedores",
            route: `/${utils.getWL()}/cadastros/vendedores`,
            svgIcon: "media/icons/duotune/communication/com013.svg",
            fontIcon: "bi-person-fill",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/cadastros/vendedores/consultar`,
              },
            ],
          };

          vendedoresRota = {
            path: "/:url/cadastros/vendedores/consultar",
            name: "cadastros/vendedores/consultar",
            component: () => import("@/views/vendedores/Consultar.vue"),
            meta: {
              pageTitle: "Vendedores",
              breadcrumbs: ["Consultar"],
            },
          };

          cadastros.pages.push(vendedoresModulo);
          rotas.push(vendedoresRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Vendedor.Incluir"
          )
        ) {
          var vendedoresAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/cadastros/vendedores/editar`,
          };

          var vendedoresAdicionarRotas = {
            path: "/:url/cadastros/vendedores/editar",
            name: "cadastros/vendedores/editar",
            component: () => import("@/views/vendedores/Editar.vue"),
            meta: {
              pageTitle: "Vendedores",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (vendedoresModulo !== null) {
            vendedoresModulo.sub.push(vendedoresAdicionarModulo);
          }

          rotas.push(vendedoresAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Vendedor.Alterar"
          )
        ) {
          var vendedoresEditarRotas = {
            path: "/:url/cadastros/vendedores/editar/:id",
            name: "cadastros/vendedores/editar/:id",
            component: () => import("@/views/vendedores/Editar.vue"),
            meta: {
              pageTitle: "Vendedores",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(vendedoresEditarRotas);
        }
        //#endregion

        //#region Menu - Cadastros - Motoristas
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Motorista.Consultar"
          )
        ) {
          motoristasModulo = {
            ordem: 6,
            sectionTitle: "Motoristas",
            route: `/${utils.getWL()}/cadastros/motoristas`,
            svgIcon: "media/icons/duotune/technology/teh002.svg",
            fontIcon: "bi-person-square",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/cadastros/motoristas/consultar`,
              },
            ],
          };

          motoristasRota = {
            path: "/:url/cadastros/motoristas/consultar",
            name: "cadastros/motoristas/consultar",
            component: () => import("@/views/motoristas/Consultar.vue"),
            meta: {
              pageTitle: "Motoristas",
              breadcrumbs: ["Consultar"],
            },
          };

          cadastros.pages.push(motoristasModulo);
          rotas.push(motoristasRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Motorista.Incluir"
          )
        ) {
          var motoristasAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/cadastros/motoristas/editar`,
          };

          var motoristasAdicionarRotas = {
            path: "/:url/cadastros/motoristas/editar",
            name: "cadastros/motoristas/editar",
            component: () => import("@/views/motoristas/Editar.vue"),
            meta: {
              pageTitle: "Motoristas",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (motoristasModulo !== null) {
            motoristasModulo.sub.push(motoristasAdicionarModulo);
          }

          rotas.push(motoristasAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Motorista.Alterar"
          )
        ) {
          var motoristasEditarRotas = {
            path: "/:url/cadastros/motoristas/editar/:id",
            name: "cadastros/motoristas/editar/:id",
            component: () => import("@/views/motoristas/Editar.vue"),
            meta: {
              pageTitle: "Motoristas",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(motoristasEditarRotas);
        }
        //#endregion

        //#endregion

        //#region Menu - Movimentação

        //#region Menu - Movimentação - Faturamento
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Faturamento.Consultar"
          )
        ) {
          faturamentoModulo = {
            ordem: 1,
            sectionTitle: "Faturamento",
            route: `/${utils.getWL()}/movimentacao/faturamento`,
            svgIcon: "media/icons/duotune/ecommerce/ecm008.svg",
            fontIcon: "bi-clipboard2-check",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/movimentacao/faturamento/consultar`,
              },
            ],
          };

          faturamentoRota = {
            path: "/:url/movimentacao/faturamento/consultar",
            name: "movimentacao/faturamento/consultar",
            component: () => import("@/views/faturamento/Consultar.vue"),
            meta: {
              pageTitle: "Faturamento",
              breadcrumbs: ["Consultar"],
            },
          };

          movimentacao.pages.push(faturamentoModulo);
          rotas.push(faturamentoRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Faturamento.Incluir"
          )
        ) {
          var faturamentoAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/movimentacao/faturamento/editar`,
          };

          var faturamentoAdicionarRotas = {
            path: "/:url/movimentacao/faturamento/editar",
            name: "movimentacao/faturamento/editar",
            component: () => import("@/views/faturamento/Editar.vue"),
            meta: {
              pageTitle: "Faturamento",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (faturamentoModulo !== null) {
            faturamentoModulo.sub.push(faturamentoAdicionarModulo);
          }

          rotas.push(faturamentoAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Faturamento.Alterar"
          )
        ) {
          var faturamentoEditarRotas = {
            path: "/:url/movimentacao/faturamento/editar/:id",
            name: "movimentacao/faturamento/editar/:id",
            component: () => import("@/views/faturamento/Editar.vue"),
            meta: {
              pageTitle: "Faturamento",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(faturamentoEditarRotas);
        }
        //#endregion

        //#region Menu - Movimentação - Gerenciar NF-e
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.GerenciadorNFe.Consultar"
          )
        ) {
          gerenciadorNFeModulo = {
            ordem: 2,
            sectionTitle: "Gerenciar NF-e",
            route: `/${utils.getWL()}/movimentacao/gerenciarNFe`,
            svgIcon: "media/icons/duotune/abstract/abs007.svg",
            fontIcon: "bi-clipboard2-check",
            sub: [
              {
                heading: "Gerenciar",
                route: `/${utils.getWL()}/movimentacao/gerenciarNFe/gerenciarnfe`,
              },
            ],
          };

          gerenciadorNFeRota = {
            path: "/:url/movimentacao/gerenciarNFe/gerenciarnfe",
            name: "movimentacao/gerenciarNFe/gerenciarnfe",
            component: () => import("@/views/gerenciarnfe/GerenciarNFe.vue"),
            meta: {
              pageTitle: "Gerenciar NF-e",
              breadcrumbs: ["Gerenciar NF-e"],
            },
          };

          movimentacao.pages.push(gerenciadorNFeModulo);
          rotas.push(gerenciadorNFeRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.GerenciadorNFe.Inutilizar"
          )
        ) {
          let gerenciadorNFeInutilizacoesModulo = {
            heading: "Inutilizações",
            route: `/${utils.getWL()}/movimentacao/gerenciarNFe/inutilizacaonfe`,
          };

          let gerencaidorNFeInutilizacaoRotas = {
            path: "/:url/movimentacao/gerenciarNFe/inutilizacaonfe",
            name: "movimentacao/gerenciarNFe/inutilizacaonfe",
            component: () => import("@/views/gerenciarnfe/InutilizacaoNFe.vue"),
            meta: {
              pageTitle: "Inutilização NF-e",
              breadcrumbs: ["Gerenciar NF-e", "Inutilização"],
            },
          };

          if (gerenciadorNFeModulo !== null) {
            gerenciadorNFeModulo.sub.push(gerenciadorNFeInutilizacoesModulo);
          }

          rotas.push(gerencaidorNFeInutilizacaoRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.GerenciadorNFe.CartaCorrecao"
          )
        ) {
          let gerenciadorNFeCartaCorrecaoModulo = {
            heading: "Carta de Correção",
            route: `/${utils.getWL()}/movimentacao/gerenciarNFe/cartacorrecaonfe`,
          };

          let gerencaidorNFeCartaCorrecaoRotas = {
            path: "/:url/movimentacao/gerenciarNFe/cartacorrecaonfe",
            name: "movimentacao/gerenciarNFe/cartacorrecaonfe",
            component: () =>
              import("@/views/gerenciarnfe/CartaCorrecaoNFe.vue"),
            meta: {
              pageTitle: "Carta de Correção NF-e",
              breadcrumbs: ["Gerenciar NF-e", "Carta de Correção"],
            },
          };

          if (gerenciadorNFeModulo !== null) {
            gerenciadorNFeModulo.sub.push(gerenciadorNFeCartaCorrecaoModulo);
          }

          rotas.push(gerencaidorNFeCartaCorrecaoRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.GerenciadorNFe.ArquivosXML"
          )
        ) {
          let gerenciadorNFeArquivosModulo = {
            heading: "Arquivos XML",
            route: `/${utils.getWL()}/movimentacao/gerenciarNFe/arquivosxml`,
          };

          let gerencaidorNFeArquivosRotas = {
            path: "/:url/movimentacao/gerenciarNFe/arquivosxml",
            name: "movimentacao/gerenciarNFe/arquivosxml",
            component: () => import("@/views/gerenciarnfe/ArquivosXMLNFe.vue"),
            meta: {
              pageTitle: "Arquivos XML",
              breadcrumbs: ["Gerenciar NF-e", "Arquivos XML"],
            },
          };

          if (gerenciadorNFeModulo !== null) {
            gerenciadorNFeModulo.sub.push(gerenciadorNFeArquivosModulo);
          }

          rotas.push(gerencaidorNFeArquivosRotas);
        }
        //#endregion

        //#region Menu - Movimentação - PDV
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.VendasCupom.Consultar"
          )
        ) {
          pdvModulo = {
            ordem: 3,
            sectionTitle: "Frente de Caixa",
            route: `/${utils.getWL()}/movimentacao/pdv`,
            svgIcon: "media/icons/duotune/ecommerce/ecm001.svg",
            fontIcon: "bi-clipboard2-check",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/movimentacao/pdv/consultar`,
              },
            ],
          };

          pdvRota = {
            path: "/:url/movimentacao/pdv/consultar",
            name: "movimentacao/pdv/consultar",
            component: () => import("@/views/pdv/Consultar.vue"),
            meta: {
              pageTitle: "Frente de Caixa",
              breadcrumbs: ["Consultar"],
            },
          };

          movimentacao.pages.push(pdvModulo);
          rotas.push(pdvRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.VendasCupom.Incluir"
          )
        ) {
          var pdvIncluirVendaModulo = {
            heading: "Venda",
            route: `/${utils.getWL()}/movimentacao/pdv/venda`,
          };

          var pdvIncluirVendaRotas = {
            path: "/:url/movimentacao/pdv/venda",
            name: "movimentacao/pdv/venda",
            component: () => import("@/views/pdv/Venda.vue"),
            meta: {
              pageTitle: "Frente de Caixa",
              breadcrumbs: ["Consultar", "Venda"],
            },
          };

          if (pdvModulo !== null) {
            pdvModulo.sub.push(pdvIncluirVendaModulo);
          }

          rotas.push(pdvIncluirVendaRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.VendasCupom.Alterar"
          )
        ) {
          var pdvEditarVendaRotas = {
            path: "/:url/movimentacao/pdv/venda/:id",
            name: "movimentacao/pdv/venda/:id",
            component: () => import("@/views/pdv/Venda.vue"),
            meta: {
              pageTitle: "Frente de Caixa",
              breadcrumbs: ["Consultar", "Venda"],
            },
          };

          rotas.push(pdvEditarVendaRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.GerenciadorNFCe.Inutilizar"
          )
        ) {
          let pdvInutilizacoesModulo = {
            heading: "Inutilizações",
            route: `/${utils.getWL()}/movimentacao/pdv/inutilizacaonfce`,
          };

          let pdvInutilizacaoRotas = {
            path: "/:url/movimentacao/pdv/inutilizacaonfce",
            name: "movimentacao/pdv/inutilizacaonfce",
            component: () => import("@/views/pdv/InutilizacaoNFCe.vue"),
            meta: {
              pageTitle: "Inutilização NFC-e",
              breadcrumbs: ["Consultar", "Inutilização"],
            },
          };

          if (pdvModulo !== null) {
            pdvModulo.sub.push(pdvInutilizacoesModulo);
          }

          rotas.push(pdvInutilizacaoRotas);
        }
        //#endregion

        //#region Menu - Movimentação - Pedidos
        if (user.User.Emitente.tipo_pacote > 1) {
          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.Pedido.Consultar"
            )
          ) {
            pedidosModulo = {
              ordem: 4,
              sectionTitle: "Pedidos",
              route: `/${utils.getWL()}/movimentacao/pedidos`,
              svgIcon: "media/icons/duotune/ecommerce/ecm002.svg",
              fontIcon: "bi-basket2",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/movimentacao/pedidos/consultar`,
                },
              ],
            };

            pedidosRota = {
              path: "/:url/movimentacao/pedidos/consultar",
              name: "movimentacao/pedidos/consultar",
              component: () => import("@/views/pedidos/Consultar.vue"),
              meta: {
                pageTitle: "Pedidos",
                breadcrumbs: ["Consultar"],
              },
            };

            movimentacao.pages.push(pedidosModulo);
            rotas.push(pedidosRota);
          }

          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.Pedido.Incluir"
            )
          ) {
            var pedidosAdicionarModulo = {
              heading: "Adicionar",
              route: `/${utils.getWL()}/movimentacao/pedidos/editar`,
            };

            var pedidosAdicionarRotas = {
              path: "/:url/movimentacao/pedidos/editar",
              name: "movimentacao/pedidos/editar",
              component: () => import("@/views/pedidos/Editar.vue"),
              meta: {
                pageTitle: "Pedidos",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            if (pedidosModulo !== null) {
              pedidosModulo.sub.push(pedidosAdicionarModulo);
            }

            rotas.push(pedidosAdicionarRotas);
          }

          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.Pedido.Alterar"
            )
          ) {
            var pedidosEditarRotas = {
              path: "/:url/movimentacao/pedidos/editar/:id",
              name: "movimentacao/pedidos/editar/:id",
              component: () => import("@/views/pedidos/Editar.vue"),
              meta: {
                pageTitle: "Pedidos",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            rotas.push(pedidosEditarRotas);
          }
        }
        //#endregion

        //#region Menu - Movimentação - Compra
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Compra.Consultar"
          )
        ) {
          compraModulo = {
            ordem: 1,
            sectionTitle: "Compras",
            route: `/${utils.getWL()}/movimentacao/compra`,
            svgIcon: "media/icons/duotune/ecommerce/ecm006.svg",
            fontIcon: "bi-clipboard2-check",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/movimentacao/compra/consultar`,
              },
            ],
          };

          compraRota = {
            path: "/:url/movimentacao/compra/consultar",
            name: "movimentacao/compra/consultar",
            component: () => import("@/views/compra/Consultar.vue"),
            meta: {
              pageTitle: "Compras",
              breadcrumbs: ["Consultar"],
            },
          };

          movimentacao.pages.push(compraModulo);
          rotas.push(compraRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Compra.Incluir"
          )
        ) {
          var compraAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/movimentacao/compra/editar`,
          };

          var compraAdicionarRotas = {
            path: "/:url/movimentacao/compra/editar",
            name: "movimentacao/compra/editar",
            component: () => import("@/views/compra/Editar.vue"),
            meta: {
              pageTitle: "Compras",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (compraModulo !== null) {
            compraModulo.sub.push(compraAdicionarModulo);
          }

          rotas.push(compraAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Compra.Alterar"
          )
        ) {
          var compraEditarRotas = {
            path: "/:url/movimentacao/compra/editar/:id",
            name: "movimentacao/compra/editar/:id",
            component: () => import("@/views/compra/Editar.vue"),
            meta: {
              pageTitle: "Compras",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(compraEditarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.ManifestoDFe.Consultar"
          )
        ) {
          let consultaManifestoDFeModulo = {
            heading: "Manifesto DF-e",
            route: `/${utils.getWL()}/movimentacao/compra/manifestodfe`,
          };

          let consultaManifestoDFeRota = {
            path: "/:url/movimentacao/compra/manifestodfe",
            name: "movimentacao/compra/manifestodfe",
            component: () => import("@/views/compra/ConsultaManifestoDFe.vue"),
            meta: {
              pageTitle: "Manifesto DF-e",
              breadcrumbs: ["Compras", "Manifesto DF-e"],
            },
          };

          if (compraModulo !== null) {
            compraModulo.sub.push(consultaManifestoDFeModulo);
          }
          rotas.push(consultaManifestoDFeRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Compra.Relatorios"
          )
        ) {
          let compraRelatoriosModulo = {
            heading: "Relatórios",
            route: `/${utils.getWL()}/movimentacao/compra/relatorios/consultar`,
          };

          let compraRelatoriosRota = {
            path: "/:url/movimentacao/compra/relatorios/consultar",
            name: "movimentacao/compra/relatorios/consultar",
            component: () => import("@/views/compra/relatorios/Consultar.vue"),
            meta: {
              pageTitle: "Relatórios de Compras",
              breadcrumbs: ["Compras", "Relatórios"],
            },
          };

          if (compraModulo !== null) {
            compraModulo.sub.push(compraRelatoriosModulo);
          }
          rotas.push(compraRelatoriosRota);
        }

        //#endregion

        //#endregion

        //#region Menu - Financeiro

        //#region Menu - Financeiro - Condições
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Condicao.Consultar"
          )
        ) {
          condicoesModulo = {
            ordem: 1,
            sectionTitle: "Condições",
            route: `/${utils.getWL()}/financeiro/condicoes`,
            svgIcon: "media/icons/duotune/ecommerce/ecm008.svg",
            fontIcon: "bi-journal-text",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/financeiro/condicoes/consultar`,
              },
            ],
          };

          condicoesRota = {
            path: "/:url/financeiro/condicoes/consultar",
            name: "financeiro/condicoes/consultar",
            component: () => import("@/views/condicoes/Consultar.vue"),
            meta: {
              pageTitle: "Condições",
              breadcrumbs: ["Consultar"],
            },
          };

          financeiro.pages.push(condicoesModulo);
          rotas.push(condicoesRota);
        }
        //#endregion

        //#region Menu - Financeiro - Espécies
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Especie.Consultar"
          )
        ) {
          especiesModulo = {
            ordem: 2,
            sectionTitle: "Espécies",
            route: `/${utils.getWL()}/financeiro/especies`,
            svgIcon: "media/icons/duotune/finance/fin008.svg",
            fontIcon: "bi-wallet2",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/financeiro/especies/consultar`,
              },
            ],
          };

          especiesRota = {
            path: "/:url/financeiro/especies/consultar",
            name: "financeiro/especies/consultar",
            component: () => import("@/views/especies/Consultar.vue"),
            meta: {
              pageTitle: "Espécies",
              breadcrumbs: ["Consultar"],
            },
          };

          financeiro.pages.push(especiesModulo);
          rotas.push(especiesRota);
        }
        //#endregion

        //#region Menu - Financeiro - Centro de Custo
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Custo.Consultar"
          )
        ) {
          custosModulo = {
            ordem: 3,
            sectionTitle: "Centro de Custo",
            route: `/${utils.getWL()}/financeiro/custos`,
            svgIcon: "media/icons/duotune/general/gen028.svg",
            fontIcon: "bi-journals",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/financeiro/custos/consultar`,
              },
            ],
          };

          custosRota = {
            path: "/:url/financeiro/custos/consultar",
            name: "financeiro/custos/consultar",
            component: () => import("@/views/custos/Consultar.vue"),
            meta: {
              pageTitle: "Centro de Custo",
              breadcrumbs: ["Consultar"],
            },
          };

          financeiro.pages.push(custosModulo);
          rotas.push(custosRota);
        }
        //#endregion

        //#region Menu - Financeiro - Plano de Contas
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Conta.Consultar"
          )
        ) {
          contasModulo = {
            ordem: 4,
            sectionTitle: "Plano de Contas",
            route: `/${utils.getWL()}/financeiro/contas`,
            svgIcon: "media/icons/duotune/files/fil002.svg",
            fontIcon: "bi-calendar3",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/financeiro/contas/consultar`,
              },
            ],
          };

          contasRota = {
            path: "/:url/financeiro/contas/consultar",
            name: "financeiro/contas/consultar",
            component: () => import("@/views/contas/Consultar.vue"),
            meta: {
              pageTitle: "Plano de Contas",
              breadcrumbs: ["Consultar"],
            },
          };

          financeiro.pages.push(contasModulo);
          rotas.push(contasRota);
        }
        //#endregion

        //#region Menu - Financeiro - Contas a Receber
        if (user.User.Emitente.tipo_pacote > 1) {
          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.Receber.Consultar"
            )
          ) {
            receberModulo = {
              ordem: 5,
              sectionTitle: "Contas a Receber",
              route: `/${utils.getWL()}/financeiro/receber`,
              svgIcon: "media/icons/duotune/files/fil018.svg",
              fontIcon: "bi-file-arrow-up",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/financeiro/receber/consultar`,
                },
              ],
            };

            receberRota = {
              path: "/:url/financeiro/receber/consultar",
              name: "financeiro/receber/consultar",
              component: () => import("@/views/receber/Consultar.vue"),
              meta: {
                pageTitle: "Contas a Receber",
                breadcrumbs: ["Consultar"],
              },
            };

            financeiro.pages.push(receberModulo);
            rotas.push(receberRota);
          }

          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.Receber.Relatorios"
            )
          ) {
            let receberRelatoriosModulo = {
              heading: "Relatórios",
              route: `/${utils.getWL()}/financeiro/receber/relatorios/consultar`,
            };

            let receberRelatoriosRota = {
              path: "/:url/financeiro/receber/relatorios/consultar",
              name: "financeiro/receber/relatorios/consultar",
              component: () =>
                import("@/views/receber/relatorios/Consultar.vue"),
              meta: {
                pageTitle: "Relatórios de Contas a Receber",
                breadcrumbs: ["Contas a Receber", "Relatórios"],
              },
            };

            if (receberModulo !== null) {
              receberModulo.sub.push(receberRelatoriosModulo);
            }
            rotas.push(receberRelatoriosRota);
          }
        }
        //#endregion

        //#region Menu - Financeiro - Contas a Pagar
        if (user.User.Emitente.tipo_pacote > 1) {
          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.Pagar.Consultar"
            )
          ) {
            pagarModulo = {
              ordem: 6,
              sectionTitle: "Contas a Pagar",
              route: `/${utils.getWL()}/financeiro/pagar`,
              svgIcon: "media/icons/duotune/files/fil017.svg",
              fontIcon: "bi-file-arrow-down",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/financeiro/pagar/consultar`,
                },
              ],
            };

            pagarRota = {
              path: "/:url/financeiro/pagar/consultar",
              name: "financeiro/pagar/consultar",
              component: () => import("@/views/pagar/Consultar.vue"),
              meta: {
                pageTitle: "Contas a Pagar",
                breadcrumbs: ["Consultar"],
              },
            };

            financeiro.pages.push(pagarModulo);
            rotas.push(pagarRota);
          }

          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.Pagar.Relatorios"
            )
          ) {
            let pagarRelatoriosModulo = {
              heading: "Relatórios",
              route: `/${utils.getWL()}/financeiro/pagar/relatorios/consultar`,
            };

            let pagarRelatoriosRota = {
              path: "/:url/financeiro/pagar/relatorios/consultar",
              name: "financeiro/pagar/relatorios/consultar",
              component: () => import("@/views/pagar/relatorios/Consultar.vue"),
              meta: {
                pageTitle: "Relatórios de Contas a Pagar",
                breadcrumbs: ["Contas a Pagar", "Relatórios"],
              },
            };

            if (pagarModulo !== null) {
              pagarModulo.sub.push(pagarRelatoriosModulo);
            }
            rotas.push(pagarRelatoriosRota);
          }
        }
        //#endregion

        //#endregion

        //#region Menu - Relatórios

        //#region Menu - Relatórios - Relatórios
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Relatorios.Executar"
          )
        ) {
          if (relatoriosModulo === null) {
            relatoriosModulo = {
              ordem: 1,
              sectionTitle: "Relatórios",
              route: `/${utils.getWL()}/relatorios`,
              svgIcon: "media/icons/duotune/graphs/gra012.svg",
              fontIcon: "bi-clipboard-data",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/relatorios/consultar`,
                },
              ],
            };
          } else {
            let consultarRelatoriosModulo = {
              heading: "Consultar",
              route: `/${utils.getWL()}/relatorios/consultar`,
            };
            relatoriosModulo.sub.push(consultarRelatoriosModulo);
          }

          relatoriosRota = {
            path: "/:url/relatorios/consultar",
            name: "relatorios/consultar",
            component: () => import("@/views/relatorios/Consultar.vue"),
            meta: {
              pageTitle: "Relatorios",
              breadcrumbs: ["Consultar"],
            },
          };

          relatorios.pages.push(relatoriosModulo);
          rotas.push(relatoriosRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Relatorios.Consultar"
          )
        ) {
          let consultarRelatoriosModulo = {
            heading: "Gerenciar",
            route: `/${utils.getWL()}/relatorios/gerenciar`,
          };

          let consultarRelatoriosRotas = {
            path: "/:url/relatorios/gerenciar",
            name: "relatorios/gerenciar",
            component: () => import("@/views/relatorios/Gerenciar.vue"),
            meta: {
              pageTitle: "Gerenciar",
              breadcrumbs: ["Relatórios", "Gerenciar"],
            },
          };

          if (relatoriosModulo !== null) {
            relatoriosModulo.sub.push(consultarRelatoriosModulo);
          } else {
            relatoriosModulo = {
              ordem: 1,
              sectionTitle: "Relatórios",
              route: `/${utils.getWL()}/relatorios`,
              svgIcon: "media/icons/duotune/graphs/gra012.svg",
              fontIcon: "bi-clipboard-data",
              sub: [
                {
                  heading: "Gerenciar",
                  route: `/${utils.getWL()}/relatorios/gerenciar`,
                },
              ],
            };
          }

          rotas.push(consultarRelatoriosRotas);
        }
        //#endregion

        //#endregion

        //#region Menu - Configurações

        //#region Menu - Configurações - Usuários
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Usuario.Consultar"
          )
        ) {
          usuariosModulo = {
            ordem: 1,
            sectionTitle: "Usuários",
            route: `/${utils.getWL()}/configuracoes/usuarios`,
            svgIcon: "media/icons/duotune/communication/com006.svg",
            fontIcon: "bi-person-circle",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/configuracoes/usuarios/consultar`,
              },
            ],
          };

          usuariosRota = {
            path: "/:url/configuracoes/usuarios/consultar",
            name: "configuracoes/usuarios/consultar",
            component: () => import("@/views/usuarios/Consultar.vue"),
            meta: {
              pageTitle: "Usuários",
              breadcrumbs: ["Consultar"],
            },
          };

          configuracoes.pages.push(usuariosModulo);
          rotas.push(usuariosRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Usuario.Incluir"
          )
        ) {
          var usuariosAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/configuracoes/usuarios/editar`,
          };

          var usuariosAdicionarRotas = {
            path: "/:url/configuracoes/usuarios/editar",
            name: "configuracoes/usuarios/editar",
            component: () => import("@/views/usuarios/Editar.vue"),
            meta: {
              pageTitle: "Usuários",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (usuariosModulo !== null) {
            usuariosModulo.sub.push(usuariosAdicionarModulo);
          }

          rotas.push(usuariosAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Usuario.Alterar"
          )
        ) {
          var usuariosEditarRotas = {
            path: "/:url/configuracoes/usuarios/editar/:id",
            name: "configuracoes/usuarios/editar/:id",
            component: () => import("@/views/usuarios/Editar.vue"),
            meta: {
              pageTitle: "Usuários",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(usuariosEditarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.SessaoUsuario.Consultar"
          )
        ) {
          let sessaoUsuarioModulo = {
            heading: "Usuários Conectados",
            route: `/${utils.getWL()}/configuracoes/usuarios/sessaousuario`,
          };

          let sessaoUsuarioRotas = {
            path: "/:url/configuracoes/usuarios/sessaousuario",
            name: "configuracoes/usuarios/sessaousuario",
            component: () => import("@/views/sessaousuarios/Consultar.vue"),
            meta: {
              pageTitle: "Usuários Conectados",
              breadcrumbs: ["Usuários", "Usuários Conectados"],
            },
          };

          if (usuariosModulo !== null) {
            usuariosModulo.sub.push(sessaoUsuarioModulo);
          }

          rotas.push(sessaoUsuarioRotas);
        }
        //#endregion

        //#region Menu - Configurações - Restrições de Usuários
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.EmitenteRestricao.Consultar"
          )
        ) {
          emitenteRestricoesModulo = {
            ordem: 2,
            sectionTitle: "Restrições de Usuários",
            route: `/${utils.getWL()}/configuracoes/emitenterestricoes`,
            svgIcon: "media/icons/duotune/general/gen049.svg",
            fontIcon: "bi-shield-x",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/configuracoes/emitenterestricoes/consultar`,
              },
            ],
          };

          emitenteRestricoesRota = {
            path: "/:url/configuracoes/emitenterestricoes/consultar",
            name: "configuracoes/emitenterestricoes/consultar",
            component: () => import("@/views/emitenterestricoes/Consultar.vue"),
            meta: {
              pageTitle: "Restrições de usuários",
              breadcrumbs: ["Consultar"],
            },
          };

          configuracoes.pages.push(emitenteRestricoesModulo);
          rotas.push(emitenteRestricoesRota);
        }

        if (
          permissoes.find(
            (modulo) =>
              modulo.regra == "Permitir.EmitenteRestricaoPadrao.Consultar"
          )
        ) {
          var emitenteRestricoesPadraoConsultarModulo = {
            heading: "Gerenciar",
            route: `/${utils.getWL()}/configuracoes/emitenterestricoes/gerenciar`,
          };

          var emitenteRestricoesPadraoConsultarRotas = {
            path: "/:url/configuracoes/emitenterestricoes/gerenciar",
            name: "configuracoes/emitenterestricoes/gerenciar",
            component: () => import("@/views/emitenterestricoes/Gerenciar.vue"),
            meta: {
              pageTitle: "Restrições de usuários",
              breadcrumbs: ["Consultar", "Gerenciar"],
            },
          };

          if (emitenteRestricoesModulo !== null) {
            emitenteRestricoesModulo.sub.push(
              emitenteRestricoesPadraoConsultarModulo
            );
          }

          rotas.push(emitenteRestricoesPadraoConsultarRotas);
        }
        //#endregion

        //#region Menu - Configurações - Configurações
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Configuracao.Consultar"
          )
        ) {
          configuracoesModulo = {
            ordem: 3,
            sectionTitle: "Configurações",
            route: `/${utils.getWL()}/configuracoes/configuracoes`,
            svgIcon: "media/icons/duotune/coding/cod001.svg",
            fontIcon: "bi bi-gear",
            sub: [
              {
                heading: "Gerenciar",
                route: `/${utils.getWL()}/configuracoes/configuracoes/gerenciar`,
              },
            ],
          };

          configuracoesRota = {
            path: "/:url/configuracoes/configuracoes/gerenciar",
            name: "configuracoes/configuracoes/gerenciar",
            component: () => import("@/views/configuracoes/Gerenciar.vue"),
            meta: {
              pageTitle: "Configurações",
              breadcrumbs: ["Gerenciar"],
            },
          };

          configuracoes.pages.push(configuracoesModulo);
          rotas.push(configuracoesRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Emitente.Consultar"
          )
        ) {
          var emitenteGerenciarModulo = {
            heading: "Emitente",
            route: `/${utils.getWL()}/configuracoes/emitente/gerenciar`,
          };

          var emitenteGerenciarRotas = {
            path: "/:url/configuracoes/emitente/gerenciar",
            name: "configuracoes/emitente/gerenciar",
            component: () => import("@/views/empresas/Editar.vue"),
            meta: {
              pageTitle: "Emitente",
              breadcrumbs: ["Gerenciar"],
            },
          };

          if (configuracoesModulo !== null) {
            configuracoesModulo.sub.push(emitenteGerenciarModulo);
          }

          rotas.push(emitenteGerenciarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Conversao.Gerenciar"
          )
        ) {
          var conversaoGerenciarModulo = {
            heading: "Conversões",
            route: `/${utils.getWL()}/configuracoes/conversao/gerenciar`,
          };

          var conversaoGerenciarRotas = {
            path: "/:url/configuracoes/conversao/gerenciar",
            name: "configuracoes/conversao/gerenciar",
            component: () => import("@/views/conversao/Gerenciar.vue"),
            meta: {
              pageTitle: "Conversões",
              breadcrumbs: ["Gerenciar"],
            },
          };

          if (configuracoesModulo !== null) {
            configuracoesModulo.sub.push(conversaoGerenciarModulo);
          }

          rotas.push(conversaoGerenciarRotas);
        }
        //#endregion

        //#region Menu - Configurações - Auditoria
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Auditoria.Consultar"
          )
        ) {
          auditoriaModulo = {
            ordem: 4,
            sectionTitle: "Auditoria",
            route: `/${utils.getWL()}/configuracoes/auditoria`,
            svgIcon: "media/icons/duotune/general/gen062.svg",
            fontIcon: "bi-pc-display-horizontal",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/configuracoes/auditoria/consultar`,
              },
            ],
          };

          auditoriaRota = {
            path: "/:url/configuracoes/auditoria/consultar",
            name: "configuracoes/auditoria/consultar",
            component: () => import("@/views/auditoria/Consultar.vue"),
            meta: {
              pageTitle: "Auditoria",
              breadcrumbs: ["Consultar"],
            },
          };

          configuracoes.pages.push(auditoriaModulo);
          rotas.push(auditoriaRota);
        }
        //#endregion

        //#endregion

        //#region Menu - Suporte

        //#region Menu - Suporte - Ajuda
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Ajuda.Consultar"
          )
        ) {
          suporteAjudaModulo = {
            ordem: 1,
            sectionTitle: "Ajuda",
            route: `/${utils.getWL()}/suporte/ajuda`,
            svgIcon: "media/icons/duotune/general/gen046.svg",
            fontIcon: "bi-question-circle-fill",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/suporte/ajuda/consultar`,
              },
            ],
          };

          suporteAjudaRota = {
            path: "/:url/suporte/ajuda/consultar",
            name: "suporte/ajuda/consultar",
            component: () => import("@/views/ajuda/ConsultarAjuda.vue"),
            meta: {
              pageTitle: "Ajuda",
              breadcrumbs: ["Consultar"],
            },
          };

          suporte.pages.push(suporteAjudaModulo);
          rotas.push(suporteAjudaRota);
        }
        //#endregion

        //#region Menu - Suporte - Ticket
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Ticket.Consultar"
          )
        ) {
          ticketModulo = {
            ordem: 2,
            sectionTitle: "Ticket",
            route: `/${utils.getWL()}/suporte/ticket`,
            svgIcon: "media/icons/duotune/communication/com007.svg",
            fontIcon: "bi-chat-left-text",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/suporte/ticket/consultar`,
              },
            ],
          };

          ticketRota = {
            path: "/:url/suporte/ticket/consultar",
            name: "suporte/ticket/consultar",
            component: () => import("@/views/tickets/Consultar.vue"),
            meta: {
              pageTitle: "Ticket",
              breadcrumbs: ["Consultar"],
            },
          };

          suporte.pages.push(ticketModulo);
          rotas.push(ticketRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Ticket.Incluir"
          )
        ) {
          var ticketAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/suporte/ticket/editar`,
          };

          var ticketAdicionarRotas = {
            path: "/:url/suporte/ticket/editar",
            name: "suporte/ticket/editar",
            component: () => import("@/views/tickets/Editar.vue"),
            meta: {
              pageTitle: "Ticket",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (ticketModulo !== null) {
            ticketModulo.sub.push(ticketAdicionarModulo);
          }

          rotas.push(ticketAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Ticket.Alterar"
          )
        ) {
          var ticketEditarRotas = {
            path: "/:url/suporte/ticket/editar/:id",
            name: "suporte/ticket/editar/:id",
            component: () => import("@/views/tickets/Editar.vue"),
            meta: {
              pageTitle: "Ticket",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(ticketEditarRotas);
        }
        //#endregion

        //#region Licença

        if (
          user.User.Emitente.Revenda.cnpj === config.revendas.gateway.cnpj ||
          user.User.Emitente.Revenda.cnpj === config.revendas.eedoc.cnpj
        ) {
          if (
            permissoesEmitente.find(
              (modulo) =>
                modulo.regra == "Permitir.LicencaFaturaEmitente.Consultar"
            )
          ) {
            licencaFaturaEmitenteModulo = {
              ordem: 1,
              sectionTitle: "Licença - Fatura",
              route: `/${utils.getWL()}/fatura/licenca`,
              svgIcon: "media/icons/duotune/finance/fin005.svg",
              fontIcon: "bi bi-toggles",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/fatura/licenca/consultar`,
                },
              ],
            };

            licencaFaturaEmitenteRota = {
              path: "/:url/fatura/licenca/consultar",
              name: "fatura/licenca/consultar",
              component: () => import("@/views/licencarecebivel/Consultar.vue"),
              meta: {
                pageTitle: "Licença - Fatura",
                breadcrumbs: ["Consultar"],
              },
            };

            licenca.pages.push(licencaFaturaEmitenteModulo);
            rotas.push(licencaFaturaEmitenteRota);
          }
        }

        //#endregion

        //#endregion

        //#endregion

        //#region Ordenação
        rotas.forEach((rota) => {
          router.addRoute("nav", rota);
        });

        if (navegacao.pages.length > 0) {
          navegacao.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(navegacao);
        }

        if (cadastros.pages.length > 0) {
          cadastros.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(cadastros);
        }

        if (movimentacao.pages.length > 0) {
          movimentacao.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(movimentacao);
        }

        if (financeiro.pages.length > 0) {
          financeiro.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(financeiro);
        }

        if (relatorios.pages.length > 0) {
          relatorios.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(relatorios);
        }

        if (configuracoes.pages.length > 0) {
          configuracoes.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(configuracoes);
        }

        if (suporte.pages.length > 0) {
          suporte.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(suporte);
        }

        if (licenca.pages.length > 0) {
          licenca.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(licenca);
        }

        //#endregion
      } catch (error) {
        console.log(error);
      }
    },
    desmontarMenu({ commit }) {
      DocMenuConfig.splice(0, DocMenuConfig.length);
      DocMenuConfig.push({
        pages: [
          {
            heading: "Dashboard",
            route: `/${utils.getWL()}/dashboard`,
            svgIcon: "media/icons/duotune/art/art002.svg",
            fontIcon: "bi-app-indicator",
          },
        ],
      });
    },
  },
  mutations: {
    montarMenu(state, menu) {
      state.menu = menu;
    },
    desmontarMenu(state) {
      state.menu = [];
    },
  },
};
